<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'Letreiros',
  components: {}
}
</script>
<style scoped>

</style>